import { ChangeDetectionStrategy, Component, computed, inject, signal, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { ClientForm } from '@lib/client-form';

import { Client } from '../schemas';
import { Auth } from '../service/auth';
import { ClientService } from '../service/client';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    MatButtonModule,
    MatToolbarModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
  ],
  templateUrl: './clients-page.html',
})
export class ClientsPage {
  canEdit = inject(Auth).isAdminOrEditor();

  private clientService = inject(ClientService);
  private dialog = inject(MatDialog);

  pending = this.clientService.pending;

  clients = computed(() => {
    let clients = this.clientService.clients();
    const fc = this.filterCommissionable();
    // If there is only one filter selected, filter the clients by the selected commissionable status
    if (fc.length) {
      clients = clients.filter(({ Commissionable = false }) => fc.includes(Commissionable));
    }
    return clients;
  });

  columnsToShow = signal(['ClientCode', 'ClientName', 'Commissionable', 'Links', 'actions']);
  private paginator = viewChild.required(MatPaginator);
  private sort = viewChild.required(MatSort);
  filter = signal('');
  filterCommissionable = signal<boolean[]>([]);

  source = computed(() => {
    const source = new MatTableDataSource(this.clients());
    source.paginator = this.paginator();
    source.sort = this.sort();
    source.filter = this.filter();
    return source;
  });

  trackBy(idx: number, row: Client) {
    return row.ClientCode;
  }

  reload() {
    this.clientService.reload();
  }

  edit(client?: Client) {
    const data = client ? { client, title: 'Update client account' } : {};
    this.dialog
      .open(ClientForm, {
        data,
      })
      .afterClosed()
      .subscribe((result) => result && this.reload());
  }
}
